<template>
    <span class="py-4" :class="{ 'truncate': truncate }">
        <template v-if="column === 'name'">
            <span class="text-base">
                {{ automation.name }}
            </span>
        </template>
        <template v-if="column === 'status'">
            <span class="flex items-center" v-if="automation.state == 'running'">
                <nio-icon class="mr-2 text-base" name="regular/controls-play" />
                {{ $t('automations.list.running') }}
            </span>

            <span class="flex items-center" v-if="automation.state == 'paused'">
                <nio-icon class="mr-2 text-base" name="regular/controls-pause" />
                {{ $t('automations.list.paused') }}
            </span>
        </template>
        <template v-if="column === 'type'">
            <span class="flex items-center" v-if="automation.type == 'sms'">
                <nio-icon class="mr-2 text-base" name="regular/messages-bubble-text_1" />
                {{ $t('automations.modal.sms') }}
            </span>

            <span class="flex items-center" v-if="automation.type == 'email'">
                <nio-icon class="mr-2 text-base" name="regular/envelope" />
                {{ $t('automations.modal.email') }}
            </span>

            <span class="flex items-center" v-if="automation.type == 'contact_preference'">
                <nio-icon class="mr-2 text-base" name="regular/single-neutral" />
                {{ $t('automations.modal.contactPreference') }}
            </span>
        </template>
        <template v-if="column === 'owner' && userFullname">
            <span class="flex items-center">
                <nio-icon class="mr-2 text-base flex-shrink-0" name="regular/single-neutral" />
                {{ userFullname }}
            </span>
        </template>
        <template v-if="column === 'weekdays'">
            <div class="flex justify-around items-center text-gray-500">
                <div
                    class="flex items-center justify-center w-10 h-10 mx-1 rounded-full"
                    :class="{ 'text-gray-700 bg-gray-200': automation.weekdays.indexOf(weekday.index) !== -1 }"
                    :key="weekday.index"
                    v-for="weekday in weekdays"
                >
                    {{ weekday.name.substring(0, 1) }}
                </div>
            </div>
        </template>
        <template v-if="column === 'actions'">
            <div class="space-x-2">
                <button
                    class="link-gray text-base"
                    @click="$emit('update')"
                >
                    <nio-icon name="regular/pencil-write" />
                </button>
                <button
                    class="link-gray text-base"
                    @click="$emit('delete')"
                >
                    <nio-icon name="regular/bin-2-alternate" />
                </button>
            </div>
        </template>
    </span>
</template>

<script>
    import { mapGetters, mapState } from 'vuex';

    export default {
        props: {
            column: {
                type: String,
                required: true,
            },
            automation: {
                type: Object,
                required: true,
            },
            truncate: {
                type: Boolean,
                default: true,
            },
        },

        computed: {
            ...mapState([
                'authUser',
            ]),

            ...mapGetters([
                'weekdays',
            ]),

            userFullname() {
                return this.authUser.account.users.find(user => {
                    return user.id == this.automation.user_id;
                })?.fullName;
            },
        },
    };
</script>
